import { useTranslations } from "next-intl";
import { useCloseDrawer } from "@hooks/use-drawer";
import Button from "@components/core/Button";
import Image from "@components/core/Image";
import OffcanvasHeader from "@components/core/Offcanvas/OffcanvasHeader";
import classNames from "classnames";

function DrawerClosetRTPNextStepsExplanation({ setStep, open }) {
  const t = useTranslations("common");

  const closeDrawer = useCloseDrawer();

  function backToChangeStep() {
    setStep("closetValidationComplete");
  }

  return (
    <div className={classNames("drawer-additional-panel", open && "open")}>
      <OffcanvasHeader
        closeButton
        onHide={closeDrawer}
        title={t("drawer.header.my_closet")}
      />

      <div className="drawer-body bg-white">
        <div className="d-flex flex-column p-4 m-2">
          <h5 className="text-center font-size-lg font-weight-bold mb-2">
            {t("drawer.modal_closet_rtp.next_steps_explanation.title")}
          </h5>
          <p className="text-center text-gray pb-4 mb-2">
            {t("drawer.modal_closet_rtp.next_steps_explanation.subtitle")}
          </p>

          <div
            style={{ minWidth: "96px", maxWidth: "96px", minHeight: "121px", maxHeight: "121px" }}
            className="mx-auto"
          >
            <Image
              src="partyNature"
              alt={t("drawer.modal_closet_rtp.next_steps_explanation.image_alt")}
              className="w-100"
            />
          </div>

          <div className="py-4 mt-4 mb-2 d-flex flex-column gap-4">
            <div>
              <p className="font-weight-bold mb-1">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_1.title")}
              </p>
              <p className="text-gray mb-0">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_1.description")}
              </p>
            </div>
            <div>
              <p className="font-weight-bold mb-1">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_2.title")}
              </p>
              <p className="text-gray mb-0">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_2.description")}
              </p>
            </div>
            <div>
              <p className="font-weight-bold mb-1">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_3.title")}
              </p>
              <p className="text-gray mb-0">
                {t("drawer.modal_closet_rtp.next_steps_explanation.step_3.description")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-3 border-top border-light">
        <Button
          onClick={backToChangeStep}
          fullWidth
        >
          {t("drawer.modal_rtc.bonus_item_explanation.got_it_btn")}
        </Button>
      </div>
    </div>
  );
}

export default DrawerClosetRTPNextStepsExplanation;
